import * as React from "react";
import { useState, useEffect } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import DataJacketList from "./DataJacketList";
import Mydatajacket from "./Mydatajacket";
import Myconnectdj from "./Myconnectdj";
import Login from "./Login";
import Protected from "./Protected";
import DataJacketDetail from "./DataJacketDetail";
import { SelectDataModalItem } from "./components/dataNetwork/selectData";
import MainHome from "./MainHome";
import Contact from "./Contact";
import Manual from "./components/accountManagement/Manual";

const Router = () => {
  const [current, setCurrent] = useState("");
  useEffect(() => {
    setRoute();
    window.addEventListener("hashchange", setRoute);
    return () => window.removeEventListener("hashchange", setRoute);
  }, []);
  function setRoute() {
    const location = window.location.href.split("/");
    const pathname = location[location.length - 1];
    setCurrent(pathname ? pathname : "home");
  }

  return (
    <HashRouter>
      <Login current={current} />
      <Routes>
        <Route exact path="/graph" element={<SelectDataModalItem />} />
        <Route
          exact
          path="/changepassword"
          element={<Protected current={current} />}
        />
        <Route
          exact
          path="/datajacket"
          element={<DataJacketDetail current={current} />}
        />
        <Route
          exact
          path="/mydata/datajacket"
          element={<Mydatajacket current={current} />}
        />
        <Route
          exact
          path="/mydata/connectdj"
          element={<Myconnectdj current={current} />}
        />
        <Route exact path="/contact" element={<Contact current={current} />} />
        <Route exact path="/datalist" element={<DataJacketList />} />
        <Route exact path="/home" element={<MainHome />} />
        <Route default path={"/"} element={<MainHome />} />
        <Route exact path="/Manual" element={<Manual />} />
      </Routes>
    </HashRouter>
  );
};

export default Router;
